/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Sync_Pending_MemberInputs */



/**
* | output |
* | --- |
* | "Not yet registered on vekn.net" |
*
* @param {Vekn_Sync_Pending_MemberInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_sync_pending_member = /** @type {((inputs?: Vekn_Sync_Pending_MemberInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Sync_Pending_MemberInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas encore inscrit sur vekn.net")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aún no registrado en vekn.net")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ainda não registrado em vekn.net")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non ancora registrato su vekn.net")
	return /** @type {LocalizedString} */ ("Not yet registered on vekn.net")
});